<template>
    <div>
        <slot :response="response" :loading="loading"></slot>
    </div>
</template>

<script>
  // require modules
  /* eslint-disable no-unused-vars */
  const _ = require('lodash');

  export default {
    name: "FetchRank",
    props: ['id'],
    data() {
      return {
        response: '',
        loading: false,
        isDev: process.env.NODE_ENV === 'development'
      }
    },
    methods: {
      fetch() {
        const vm = this
        const embdId = vm.id

        // /* eslint-disable no-console */
        // console.log(vm.incDesc);

        vm.loading = true

        let url = `/api/embd_rank/${embdId}`;

        if(vm.isDev) {
          url = `http://localhost:3000/api/embd_rank/${embdId}`;
        }

        // console.log(url)

        if (embdId > 0) {
          fetch(url)
            .then(response => response.json())
            .then((response) => {
              // /* eslint-disable no-console */
              // console.log(response);

              setTimeout(() => {
                vm.loading = false;
                vm.response = response
              }, 10);
            });
        } else {
          vm.loading = false;
          vm.response = ''
        }
      }
    },
    mounted() {
      const vm = this
      // /* eslint-disable no-console */
      // console.log(vm.id);
      vm.fetch()
    }
  }
</script>

<style scoped>

</style>